import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';

const Revenue = ({data}) => {

  const {
    vatRevenue, 
    vatServiceFee,
    netRevenue,
    netServiceFee,
    grossRevenue,
    grossServiceFee
  } = data;

  const totalVAT = vatRevenue - vatServiceFee;
  const totalNet =  netRevenue - netServiceFee;
  const totalGross = grossRevenue - grossServiceFee;

  return (
    <div className="mb-6">
      <h3 className="text-[16px] font-semibold mb-2">Revenue</h3>

      <TableContainer>
        <Table 
          aria-label="revenue table" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Type</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Net</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>VAT</TableCell>
              <TableCell align='right' sx={{fontWeight: 'bold'}}>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Charger Usage</TableCell>
              <TableCell>{`£${netRevenue.toFixed(2)}`}</TableCell>
              <TableCell>{`£${vatRevenue.toFixed(2)}`}</TableCell>
              <TableCell align='right'>{`£${grossRevenue.toFixed(2)}`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Service Fee</TableCell>
              <TableCell>{`£${netServiceFee.toFixed(2)}`}</TableCell>
              <TableCell>{`£${vatServiceFee.toFixed(2)}`}</TableCell>
              <TableCell align='right'>{`£${grossServiceFee.toFixed(2)}`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Total</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>{`£${totalNet.toFixed(2)}`}</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>{`£${totalVAT.toFixed(2)}`}</TableCell>
              <TableCell sx={{fontWeight: 'bold'}} align='right'>{`£${totalGross.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default Revenue;

Revenue.propTypes = {
  data: PropTypes.object.isRequired,
};